export default __webpack_public_path__ + "static/media/IMG_0518-10.106cad86.jpg";